import styled from "styled-components";

export const ButtonPrimary = styled.button`
  padding: 8px 16px;
  background-color: #f39c12;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: #e67e22;
  }
`;